import { getApiKey } from "../../utils/apiKey";
import axios from "axios";
import React, { Component } from "react";
import { apiCall_domain } from "../api";
import ItemCount from "../global/itemCount";

class CartItem extends Component {
  state = {
    count: 0,
    maxOrder: this.props.max_per_order,
    haveOrg: false,
    minPerOrder: this.props.data.min_per_order,
  };
  componentDidMount() {
    this.setState({
      count: this.props.data.count,
      haveOrg: this.props.haveOrg,
    });
  }
  removeFromCart = () => {
    const config = {
      Authorization: getApiKey(),
      "content-type": "application/json",
    };
    axios
      .post(
        `${apiCall_domain}/customer/shopping-cart/${
          this.props.data.vendor_item_id
        }?is_major=${0}`,
        {},
        { headers: config },
      )
      .then((res) => {
        this.props.getShoppingCart();
      });
  };
  increaseCount = () => {
    if (this.state.count <= this.props.data.stock) {
      if (this.state.count <= this.props.data.max_per_order) {
        this.setState({ count: this.state.count + 1 }, () => {
          this.updateCart();
        });
      }
    }
  };
  decreaseCount = () => {
    if (this.state.count >= this.state.minPerOrder) {
      this.setState({ count: this.state.count - 1 }, () => {
        this.updateCart();
      });
    }
  };
  updateCart = () => {
    const config = {
      Authorization: getApiKey(),
      "content-type": "application/json",
    };
    const {
      vendor_item_id,
      is_pack,
      install_need,
      depot_id,
      service_type,
      date,
      time,
      address_id,
    } = this.props.data;
    let data;
    switch (service_type) {
      case 0:
        data = {
          item_id: vendor_item_id,
          is_pack: is_pack,
          count: this.state.count,
          is_major: 0,
          install_need,
          depot_id,
          service_type,
          day: date.gregorian,
          time_id: time.id,
        };
        break;
      case 1:
        data = {
          item_id: vendor_item_id,
          is_pack: is_pack,
          is_major: 0,
          count: this.state.count,
          install_need,
          address_id,
          service_type,
          day: date.gregorian,
          time_id: time.id,
        };
        break;
      default:
        data = {
          item_id: vendor_item_id,
          is_pack: is_pack,
          is_major: 0,
          count: this.state.count,
          install_need,
          service_type,
        };
        break;
    }
    axios
      .post(`${apiCall_domain}/customer/shopping-cart?is_major=0`, data, {
        headers: config,
      })
      .then((res) => {
        this.props.getShoppingCart();
        this.props.calculate(
          this.state.products,
          0,
          this.state.selectedAddress?.id || null,
          this.state.selectedDelivery || 1,
          this.state.discountCode || null,
        );
      });
  };
  render() {
    const {
      name,
      pic,
      store_name,
      time,
      guaranty_month,
      service_name,
      depot_address,
      address,
      date,
      price,
      service_type,
      install_need,
      is_tire,
      variant_title,
      min_per_order,
    } = this.props.data;

    return (
      <>
        <div className="cartBody DifferentCartBody">
          <div className="cartTop">
            <p>
              {name} {variant_title ? `- ${variant_title}` : ""}
            </p>
          </div>
          <div className="cartMiddleBody">
            <div className="Pictures">
              <div className="ImgTop">
                <img src={pic} alt="install" />
              </div>
              <div className="ImgBottom">
                <div
                  className={`installType ${
                    !!install_need ? "withInstall" : "withoutInstall"
                  }`}
                >
                  {!!install_need ? (
                    <i className="icon-with-service" />
                  ) : (
                    <i className="icon-without-service" />
                  )}
                  {service_name ? "نصب " + service_name : "بدون نصب"}
                </div>
              </div>
            </div>
            <div className="cartMiddle">
              <div className="cartMiddleRow">
                <img src="/public/assets/icons/Kachar.svg" alt="یک" />
                <p className="flexP">{store_name}</p>
              </div>
              <div className="cartMiddleRow">
                <img src="/public/assets/icons/kachargaranti.svg" alt="سه" />
                <p className="flexP">{guaranty_month} ماه گارانتی</p>
              </div>
              <div className="cartMiddleRow">
                <img src="/public/assets/icons/serviceTYpe.svg" alt="چهار" />
                <p className="flexPp">
                  سرویس :
                  <span className="flexPSpan">
                    {service_name ? service_name : "بدون سرویس نصب"}
                  </span>
                </p>
              </div>
              {service_type ? (
                <>
                  <div className="cartMiddleRow">
                    <img
                      src="/public/assets/icons/locationShop.svg"
                      alt="پنج"
                    />
                    <p className="flexPp">
                      آدرس :
                      {depot_address !== null ? (
                        <span className="flexPSpan">{depot_address}</span>
                      ) : (
                        <span className="flexPSpan">{address}</span>
                      )}
                    </p>
                  </div>
                  <div className="cartMiddleRow">
                    <img
                      width={15}
                      src="/public/assets/icons/time.svg"
                      alt="time"
                    />
                    <p className="flexPp">
                      تاریخ و زمان :
                      <span className="flexPSpan">{date.jalali} </span>
                      <span className="flexPSpan">
                        از {time?.start_ts} تا {time?.stop_ts}
                      </span>
                    </p>
                  </div>
                </>
              ) : null}
            </div>
          </div>
          <div className="cartMiddleBottom">
            <div className="cartMiddleBottomRight">
              <span className="TotalCost">هزینه کلی</span>
              <span className="Toman">
                {price?.toLocaleString() || "0"} تومان
              </span>
            </div>
            <ItemCount
              data={{
                isTire: is_tire,
                count: this.state.count,
                maxOrder: this.state.maxOrder,
                minPerOrder: min_per_order,
              }}
              methods={{
                increase: this.increaseCount,
                decrease: this.decreaseCount,
                removeFromCart: this.removeFromCart,
              }}
            />
          </div>
        </div>
      </>
    );
  }
}

export default CartItem;
